import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SvgIconStyle from "~src/components/SvgIconStyle";
import { NavSectionVertical } from "~src/components/nav-section";
import useAuth from "~src/hooks/useAuth";
import { toTitleCase } from "~src/utils/string";
import footerNavConfig from "./FooterNavConfig";

export const NavbarFooter = ({ isCollapse }: { isCollapse?: boolean }) => {
  const theme = useTheme();

  return (
    <Stack spacing={1}>
      <NavSectionVertical navConfig={footerNavConfig} isCollapse={isCollapse} />
      {isCollapse && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            pb: theme.spacing(3),
          }}
        >
          <Avatar />
        </Box>
      )}
      {!isCollapse && (
        <>
          <Divider
            sx={{
              marginX: theme.spacing(2),
              borderColor: theme.palette.grey[200],
            }}
          />
          <ProfileSection />
        </>
      )}
    </Stack>
  );
};

const ProfileSection = () => {
  const theme = useTheme();
  const { user, logout } = useAuth();
  return (
    <Stack
      spacing={2}
      direction={"row"}
      sx={{
        pt: theme.spacing(2),
        pb: theme.spacing(3),
        paddingX: theme.spacing(2),
      }}
    >
      <Avatar />
      <Box>
        <Typography variant="subtitle2">{user?.name}</Typography>
        <Typography variant="body2" color={theme.palette.grey[600]}>
          {toTitleCase(user?.role || "")}
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={logout}
          sx={{
            width: 42,
            height: 42,
          }}
        >
          <SvgIconStyle
            src={`/assets/icons/navbar/logout.svg`}
            sx={{ width: 1, height: 1 }}
          />
        </IconButton>
      </Box>
    </Stack>
  );
};
